import styled from 'styled-components'

export const AppContainer = styled.div`
    display:flex;
    flex-direction: column;
    text-align: left;
    justify-content: space-between;
    min-height: 100vh;
`